/* eslint-disable import/order */
/* eslint-disable import/extensions */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/global'
import Transiction from '../../components/Transition'
import { post } from '../ClientActions'
import Form from './Form'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import { Grid, makeStyles } from '@material-ui/core'
import colors from '../../../assets/colors'
import { useHistory } from 'react-router-dom'

const Transition = React.forwardRef((props, ref) => {
  return <Transiction propis={props} refi={ref} />
})

const useStyles = makeStyles({
  rowMessage: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    fontWeight: 'normal',
  },
  btnCalendar: {
    color: '#FFFF',
    fontSize: '14px',
    backgroundColor: colors.primary,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.6,
      backgroundColor: colors.primary,
    },
  },
})

function NewClient(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const history = useHistory()

  const styles = useStyles()

  const onSubmit = values => {
    dispatch(post(values)).then(data => {
      if (data && data.code === 200) {
        onClose()
      }
    })
  }

  const onClose = () => {
    history.goBack()
  }

  return (
    <BaseCreatePage page="Clientes" path="Cadastro" hiddenReturn goBack>
      <Grid
        container
        xs={12}
        alignContent="center"
        justifyContent="flex-start"
        className={styles.rowMessage}
      >
        <Grid item xs={8} className={styles.message}>
          Utilize os campos abaixo para cadastrar um novo cliente
        </Grid>
      </Grid>

      <Form
        classes={classes}
        onClose={onClose}
        onSubmit={onSubmit}
        btnText="Salvar"
      />
    </BaseCreatePage>
  )
}

export default withStyles(styles)(NewClient)
